import { getMetrics } from "../../services/MetricService";
import { Capability } from "../../types/Capability";
import { selectUserHasCapability, selectUserToken } from "../selectors/userSelectors";
import { setData, setLoading, setError } from "../slices/metricSlice";
import { AppThunk } from "../store";

export const fetchMetricData = (): AppThunk => async (dispatch, getState) => {
    const state = getState();
    const hasDashboardCapability = selectUserHasCapability(
        state,
        Capability.CAP_FLEETAPP_DASHBOARD
    );

    if (hasDashboardCapability) {
        const userToken = selectUserToken(state);
        
        if (userToken) {
            try {
                const response = await getMetrics(userToken);

                if (response) {
                    dispatch(setData(response));
                } else {
                    throw Error("no metric data");
                }
            } catch (e) {
                console.error(e);
                dispatch(setError(true));
            }
        }
    }

    dispatch(setLoading(false));
};